export default "__VITE_ASSET__e4b416bb__"